var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimecardSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5C2.22386 5.5 2 5.27614 2 5C2 4.72386 2.22386 4.5 2.5 4.5H7.5C7.77614 4.5 8 4.72386 8 5C8 5.27614 7.77614 5.5 7.5 5.5L2.5 5.5Z",
    fill: "#3C5873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 7.27614 2.22386 7.5 2.5 7.5H5.5C5.77614 7.5 6 7.27614 6 7C6 6.72386 5.77614 6.5 5.5 6.5H2.5C2.22386 6.5 2 6.72386 2 7Z",
    fill: "#3C5873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0C2.22386 0 2 0.223858 2 0.5V1H1C0.447716 1 0 1.44771 0 2V9C0 10.1046 0.895431 11 2 11H8C9.10457 11 10 10.1046 10 9V2C10 1.44772 9.55229 1 9 1H8V0.5C8 0.223858 7.77614 0 7.5 0C7.22386 0 7 0.223858 7 0.5V1H5.5V0.5C5.5 0.223858 5.27614 0 5 0C4.72386 0 4.5 0.223858 4.5 0.5V1H3V0.5C3 0.223858 2.77614 0 2.5 0ZM7 2H5.5V2.5C5.5 2.77614 5.27614 3 5 3C4.72386 3 4.5 2.77614 4.5 2.5V2H3V2.5C3 2.77614 2.77614 3 2.5 3C2.22386 3 2 2.77614 2 2.5V2H1.5C1.22386 2 1 2.22386 1 2.5V9C1 9.55228 1.44772 10 2 10H8C8.55228 10 9 9.55228 9 9V2.5C9 2.22386 8.77614 2 8.5 2H8V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V2Z",
    fill: "#3C5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecardSummary);
export default __webpack_public_path__ + "static/media/timecard-summary.21d1a5e4.svg";
export { ForwardRef as ReactComponent };